import { createSlice } from '@reduxjs/toolkit';

const featureSwitchByMultipleValuesSlice = createSlice({
  name: 'featureSwitchByMultipleValues',
  initialState: {
    loading: false,
    featureSwitchByMultipleValues: null,
    error: true,
    success: false
  },
  reducers: {
    fetchFeatureSwitchByMultipleValuesRequest(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    fetchFeatureSwitchByMultipleValuesSuccess(state, action) {
      state.loading = false;
      state.featureSwitchByMultipleValues = action.payload;
      state.success = true;
      state.error=false;
    },
    fetchFeatureSwitchByMultipleValuesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      state.featureSwitchByMultipleValues=false;
    },
  },
});

export const { fetchFeatureSwitchByMultipleValuesRequest, fetchFeatureSwitchByMultipleValuesSuccess, fetchFeatureSwitchByMultipleValuesFailure } = featureSwitchByMultipleValuesSlice.actions;
export default featureSwitchByMultipleValuesSlice.reducer;
